"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnPathnameChange = void 0;
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var useOnPathnameChange = function (callback) {
    var location = (0, react_router_dom_1.useLocation)();
    var initialPathname = (0, react_1.useRef)(location.pathname);
    (0, react_1.useEffect)(function () {
        if (location.pathname !== initialPathname.current) {
            callback();
            initialPathname.current = location.pathname;
        }
    }, [location.pathname, callback]);
};
exports.useOnPathnameChange = useOnPathnameChange;
